import React from 'react';
import { parse } from 'querystring';
import { useLocation, useParams } from '@reach/router';

import {
  CookieBannerMode,
  PublicEWebinarFragment,
  PublicSetFragment,
} from '$/GraphQL/schema/schema';
import { FBPixelContextProvider } from '$/utils/useFBPixel';
import { PageMode } from '$/components/ui/Input/PageBuilder.types';
import { GdprContext } from '$/components/GdprCookie/GdprContext';

import RegistrationFormModal from '$/sections/Home/WebinarEditor/RegistrationPages/RegistrationForm/RegistrationFormModal';
import { AttendeeInfoFields } from '$/sections/Home/WebinarEditor/RegistrationPages/RegistrationForm/types';
import EDate from '$/shared/frontend/utils/EDate';

const RegistrationForm: React.FC<{
  set: PublicSetFragment;
  ewebinar: PublicEWebinarFragment;
  pixelID?: string;
  isWidget?: boolean;
  defaultInfo?: AttendeeInfoFields;
  justInTimeDate?: EDate;
  justInTimeName?: string;
  onClose?: () => void;
  onSuccess?: (attendeeId: string, setId: string, sessionType?: string | null) => void;
}> = ({
  set,
  ewebinar,
  pixelID,
  isWidget,
  defaultInfo,
  justInTimeDate,
  justInTimeName,
  onClose,
  onSuccess,
}) => {
  const params = useParams();
  const location = useLocation();
  const query = parse(location.search) as {
    isAcceptedCookies?: string;
  } & { [key: string]: string }; // For any propertyName values
  const isAcceptedCookiesQuery = params?.isAcceptedCookies || query?.isAcceptedCookies;
  const { isAcceptedCookies } = React.useContext(GdprContext);

  const isSSR = typeof window === 'undefined';

  if (isSSR) {
    return null;
  }

  return (
    <FBPixelContextProvider
      pixelID={pixelID}
      isAcceptedCookies={
        isAcceptedCookiesQuery ||
        set.team.settings.gdpr?.bannerMode === CookieBannerMode.Off ||
        isAcceptedCookies
      }
    >
      <RegistrationFormModal
        isWidget={isWidget}
        mode={PageMode.public}
        ewebinar={ewebinar}
        set={set}
        defaultInfo={defaultInfo}
        justInTimeDate={justInTimeDate}
        justInTimeName={justInTimeName}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </FBPixelContextProvider>
  );
};

export default RegistrationForm;
